module.exports = __webpack_public_path__ + "static/media/clipboard.056ab78d.svg";